import React from 'react';
import { GENDER_ICONS } from '../clothIcons';
import { GenderSetting } from '../config/clothTypes';

interface CategoryStepProps {
  gender: GenderSetting;
  onSelect: (gender: GenderSetting) => void;
}

const CATEGORY_OPTIONS: { value: GenderSetting; label: string; icon: string; hint: string }[] = [
  { value: 'female', label: 'Female', icon: GENDER_ICONS.female, hint: "Women's garments" },
  { value: 'male', label: 'Male', icon: GENDER_ICONS.male, hint: "Men's garments" },
];

const CategoryStep: React.FC<CategoryStepProps> = ({ gender, onSelect }) => (
  <div className="mx-auto w-full max-w-3xl py-2">
    <div className="rounded-2xl border border-gray-200 bg-gray-50/50 p-6 text-center shadow-sm sm:p-8">
      <h4 className="text-sm font-bold uppercase tracking-wider text-gray-700">Design Category</h4>
      <p className="mb-6 mt-1 text-sm text-gray-500">Who are we designing for?</p>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {CATEGORY_OPTIONS.map((option) => {
          const isSelected = gender === option.value;
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => onSelect(option.value)}
              className={`relative overflow-hidden rounded-2xl border-2 p-8 transition-all duration-300 ${
                isSelected
                  ? 'border-secondary-500 bg-white shadow-md'
                  : 'border-gray-200 bg-white hover:-translate-y-0.5 hover:border-gray-300 hover:shadow-sm'
              }`}
            >
              <div className="text-5xl sm:text-6xl">{option.icon}</div>
              <div className="mt-4 text-lg font-bold text-gray-900">{option.label}</div>
              <div className="mt-1 text-xs text-gray-500">{option.hint}</div>
              {isSelected && (
                <span className="absolute right-3 top-3 rounded-full bg-secondary-500 p-1 text-white">
                  <i className="fas fa-check text-[10px]" />
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  </div>
);

export default CategoryStep;
